export const connectorSettings = {
  DeviantArt: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/deviantart/connect',
    disconnectPath: '/services/deviantart/disconnect',
    parameterName: 'daact'
  },
  Picasa: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/google/connect',
    disconnectPath: '/services/google/disconnect',
    parameterName: 'goglact'
  },
  GooglePhotos: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/google_photos/connect',
    disconnectPath: '/services/google_photos/disconnect',
    parameterName: 'gphact'
  },
  Dribbble: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/dribble/connect',
    disconnectPath: '/services/dribble/disconnect',
    parameterName: 'dract'
  },
  Drive: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/gdrive/connect',
    disconnectPath: '/services/gdrive/disconnect',
    parameterName: 'gdrvact'
  },
  Dropbox: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/dropbox/connect',
    disconnectPath: '/services/dropbox/disconnect',
    parameterName: 'dbact'
  },
  Instagram: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/instagram/connect',
    disconnectPath: '/services/instagram/disconnect',
    parameterName: 'instact'
  },
  InstagramVideo: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/instagram/connect',
    disconnectPath: '/services/instagram/disconnect',
    parameterName: 'instact'
  },
  Facebook: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/facebook/connect',
    disconnectPath: '/services/facebook/disconnect',
    parameterName: 'fbact'
  },
  FacebookVideo: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/facebook/connect',
    disconnectPath: '/services/facebook/disconnect',
    parameterName: 'fbact'
  },
  Flickr: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/flickr/connect',
    disconnectPath: '/services/flickr/disconnect',
    parameterName: 'flact'
  },
  Youtube: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/youtube/connect',
    disconnectPath: '/services/youtube/disconnect',
    parameterName: 'ytact'
  },
  Vimeo: {
    apiUrl: 'https://pix.wix.com',
    connectPath: '/services/vimeo/connect',
    disconnectPath: '/services/vimeo/disconnect',
    parameterName: 'vmact'
  }
};